import { Lock } from "lucide-react";

import { cn } from "@/lib/utils";
import { useCapabilityContext } from "@/providers/CapabilitiesProvider";

type LockedBadgeProps = {
  feature?: string;
  className?: string;
};

export function LockedBadge({ feature, className }: LockedBadgeProps) {
  const { openUpgradeModal } = useCapabilityContext();
  return (
    <button
      type="button"
      onClick={() => openUpgradeModal(feature)}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-primary/40 bg-background/50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary transition-all duration-200 hover:border-primary hover:bg-primary/10",
        className,
      )}
    >
      <Lock className="h-3 w-3" />
      Upgrade
    </button>
  );
}
